<script setup lang="ts">
import GenerateButton from "@/components/AccountParts/GenerateButton.vue"
import { generatePassword } from "@/services/functions"
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue', 'displayError'])
const props = defineProps<{
  modelValue: string
  buttonName?: string
  driverId: string
  class?: string
}>()

const passwordGenerationErrorMessage: string[] = [i18n.global.t('pages.accounts.messages.passwordGenerationError')]

function makePassword() {
  if (!props.driverId) return emits('displayError', passwordGenerationErrorMessage)
  const password = generatePassword(props.driverId)
  emits("update:modelValue",  password)
  emits('displayError', [])
}
</script>
<template>
  <div :class="props.class">
    <GenerateButton
      :buttonName="props.buttonName"
      @generate="makePassword"
    />
  </div>
</template>
